import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import ProjectItem from './ProjectItem';
import { useScrollAnimation, fadeInUp } from '../hooks/useScrollAnimation';

const ProjectsSection = () => {
  const [titleRef, titleControls] = useScrollAnimation();
  // Sample projects - EASILY CUSTOMIZE WITH YOUR OWN PROJECTS!
  // Just update the image URLs, descriptions, and technologies
  const projects = [
    {
      title: 'Aras PLM Custom Plugin',
      description:
        'Developed a comprehensive custom plugin for Aras Innovator PLM system to handle complex workflow automations and document management. Integrated with existing enterprise systems and implemented advanced business logic for manufacturing processes. Managed deployment across multiple environments.',
      image: '', // Add your project screenshot URL here
      tags: ['Aras Innovator', 'C#', 'JavaScript', 'SQL Server', 'PLM', 'Product Management'],
    },
    {
      title: 'ZUGFeRD Invoice Processing System',
      description:
        'Built an automated XRechnung and ZUGFeRD invoice processing service for enterprise clients. Handles electronic invoice generation, validation, and compliance with German e-invoicing standards. Integrated with existing ERP systems with high-volume processing capabilities.',
      image: '', // Add your project screenshot URL here
      tags: ['C#', 'ZUGFeRD', 'XRechnung', 'XML', 'PDF', 'Enterprise Integration'],
    },
    {
      title: 'E-Commerce Platform with CI/CD',
      description:
        'Full-stack e-commerce solution with React frontend, Node.js backend, and PostgreSQL database. Implemented complete CI/CD pipeline using GitHub Actions, Docker containerization, and automated deployment to cloud infrastructure. Features include real-time inventory, payment integration, and admin dashboard.',
      image: '', // Add your project screenshot URL here
      tags: ['React', 'Node.js', 'PostgreSQL', 'Docker', 'GitHub Actions', 'CI/CD', 'AWS'],
    },
    {
      title: 'Teamcenter PLM Integration',
      description:
        'Complex enterprise integration project connecting Teamcenter PLM with manufacturing execution systems. Built custom adapters, handled complex deployment scenarios, and created automated data synchronization workflows. Improved operational efficiency by 40%.',
      image: '', // Add your project screenshot URL here
      tags: ['Teamcenter', 'Java', 'Oracle', 'Enterprise Integration', 'Complex Deployment'],
    },
    {
      title: 'Mobile Banking Application',
      description:
        'Cross-platform mobile banking app built with React Native for iOS and Android. Features biometric authentication, real-time transactions, financial analytics, and push notifications. Bank-grade security with end-to-end encryption and secure token management.',
      image: '', // Add your project screenshot URL here
      tags: ['React Native', 'TypeScript', 'Firebase', 'iOS', 'Android', 'Security'],
    },
    {
      title: 'WordPress Multi-Site Enterprise Solution',
      description:
        'Developed a custom WordPress multi-site network for large enterprise with custom plugins for content management, user authentication, and third-party integrations. Built custom admin dashboard and automated deployment pipeline using Docker and CI/CD.',
      image: '', // Add your project screenshot URL here
      tags: ['WordPress', 'PHP', 'MySQL', 'Docker', 'Plugin Development', 'Linux'],
    },
    {
      title: 'Desktop Application for Data Processing',
      description:
        'High-performance desktop application for processing and analyzing large datasets. Built with modern desktop frameworks, featuring real-time data visualization, export capabilities, and integration with cloud services. Optimized for performance with multi-threading.',
      image: '', // Add your project screenshot URL here
      tags: ['C#', '.NET', 'Desktop App', 'Data Processing', 'Performance Optimization'],
    },
    {
      title: 'Kubernetes Infrastructure Platform',
      description:
        'Designed and implemented complete Kubernetes-based infrastructure for microservices deployment. Configured Docker images, set up CI/CD pipelines, implemented monitoring and logging, and managed Linux server clusters. Automated scaling and zero-downtime deployments.',
      image: '', // Add your project screenshot URL here
      tags: ['Kubernetes', 'Docker', 'Linux', 'DevOps', 'CI/CD', 'Monitoring', 'Automation'],
    },
  ];

  return (
    <Box
      id="projects"
      sx={{
        py: { xs: 10, md: 15 },
      }}
    >
      <Container maxWidth="xl">
        <Box 
          component={motion.div}
          ref={titleRef}
          initial="hidden"
          animate={titleControls}
          variants={fadeInUp}
          sx={{ mb: 8, textAlign: 'center' }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.5rem', md: '4rem' },
              mb: 2,
            }}
          >
            Featured Projects
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              maxWidth: '700px',
              mx: 'auto',
            }}
          >
            A showcase of successful projects delivered across enterprise PLM, web, mobile, and infrastructure
          </Typography>
        </Box>

        {projects.map((project, idx) => (
          <ProjectItem key={idx} project={project} index={idx} />
        ))}
      </Container>
    </Box>
  );
};

export default ProjectsSection;
